import React from 'react';
import styles from "./Card.module.sass"

interface CardProps {
    img : string,
    name: string,
    price: string,
    href: string
}

export const Card : React.FC<CardProps> = ({img,name,price, href}) => {
    return (
        <div className={styles.card__wrap}>
            <a className={styles.card__link} href={href} target='_blank'></a>
            <img className={styles.card__img} src={img} alt=""/>
            <div className={styles.card__text__wrap}>
                <span className={styles.card__text__name}>{name}</span>
            </div>
        </div>
    );
};